import { render, staticRenderFns } from "./assetTypesList.vue?vue&type=template&id=4f1f6cb7"
import script from "./assetTypesList.vue?vue&type=script&lang=js"
export * from "./assetTypesList.vue?vue&type=script&lang=js"
import style0 from "./assetTypesList.vue?vue&type=style&index=0&id=4f1f6cb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports